import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  import { controls } from "../../controls";
  
  
  const recurringdeposit = {
    label: "Recurring Deposite",
    pageLabel: "Recurring Deposite",
    starting: true,
    url: "recurringdeposit",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form:[
       
          ...controls.displayText({label:"As On Date/Opening Date",width:"col-sm-2"}),
          {
            inputType: "showdata",
            tab: "recurringdeposit",
            displaytype:'date',
            data: "as_on_date",
            textcolor: "black",
            name: "as_on_date",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
          },
          ...controls.displayText({ width:"col-sm-6"}),

          {
            inputType: "displaytext",
            tab: "recurringdeposit",
            star:true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Installment Amount",
            label: "Installment Amount",
            name: "",
            description: "Enter Installment Amount"
          },
          {
            inputType: "numberonly",
            isRequired: true,
            tab: "recurringdeposit",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Enter Installment Amount",
            label: "",
            name: "installment_amount",
            description: "Enter Installment Amount"

          },
          ...controls.displayText({ width:"col-sm-6"}),
          ...controls.displayText({tab:"recurringdeposit",label: "No Of Installment",width:"col-sm-2"}),

          ...controls.numberofinstallment({ tab: "recurringdeposit" }),
          ...controls.displayText({ width:"col-sm-6"}),
         
          {
            inputType: "displaytext",
            tab: "recurringdeposit",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Maturity Date",
            name: "",
            description: ""
          },
          {
            inputType: "showdata",
            tab: "recurringdeposit",
            data: "maturity_date",
            displaytype:'date',
            name:"maturity_date",
            textcolor: "black",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            parents: [
              {
                name: "Recurring_Account.no_of_installment",
                match: "exist",
                show:'blank'
              }
            ],
          },
          ...controls.displayText({ width:"col-sm-6"}),
          {
            inputType: "displaytext",
            tab: "recurringdeposit",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Interest Rate",
            name: "",
            description: ""
          },
          {
            inputType: "showdata",
            tab: "recurringdeposit",
            data: "ints_rate",
            name: "ints_rate",
            textcolor: "black",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            }
          },
          ...controls.displayText({ width:"col-sm-6"}),
          {
            inputType: "displaytext",
            tab: "recurringdeposit",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Maturity Amount",
            name: "",
            description: ""
          },
          {
            inputType: "showdata",
            tab: "recurringdeposit",
            data: "maturity_amount_rd",
            displaytype:'currency',
            name:"maturity_amount_rd",
            textcolor: "black",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            parents: [
              {
                name: "Recurring_Account.no_of_installment",
                match: "exist",
                show:'blank'
              }
            ],
          },
        
          
          {
            inputType: "table",
            tableTitle: "",
            editable:true,
            printable:true,
            // defaultValue:[{trdate:'',days:'',},{}],
            tableHeaders: [
              { label: "Date",isRequired:true, field: "trdate", displaytype: 'date'},
              { label: "Days", field: "days" },
              { label: "Months", field: "months" },
              { label: "Interest", field: "interest", displaytype: 'currency' },
            ],
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            description:"Interest Schedule Table",
            name: "recurringintsche_table",
            // displayData: { ReadIntRate: "ints_rate",GetAddDate:'maturity_date',GenerateInterestSchedule:"intsche_table" },
            onRender: [
              // // sum last column of the current table
              { f: 'tableCalculations',calcType:'sum', inputs: {source:'pageData.Recurring_Account.recurringintsche_table',field:'interest' },resultVar: 'totalInterest' },
              {f :'setParentState' ,inputs:{dest:"pageData.Recurring_Account.maturity_total_rd",source:'allResults',field:'totalInterest'},resultVar:"abc" },

              // { f: 'simpleArithmatic',calcType:'sum', inputs: [{source:'allResults', field: 'totalInterest'}, { source: 'pageData.Deposits.deposit_amount' }], resultVar: 'total' },
              // // and set it as some other parentState.
              // { f: 'setParentState', inputs: { dest:"pageData.Deposits.maturity_amount_display", source:'allResults',field: 'total' },resultVar:"maturity_amount" },
              
              { f: 'dateOperations', inputs: [{ source: 'pageData.account_opening_date', type: 'date' }, { source: 'pageData.Recurring_Account.no_of_installment', type: 'months' }], resultVar: "maturity_date" },
              { f: 'setParentState', inputs: { dest: "pageData.Recurring_Account.maturity_date", source: 'allResults',field:'maturity_date' }, resultVar: "xyz" },

              {f :'setParentState' ,inputs:{dest:"pageData.interest_rate",source:'pageData.Recurring_Account.ints_rate',},resultVar:"interest_rate" },

              { f: 'setParentState', inputs: { dest:"pageData.Recurring_Account.as_on_date", source:'pageData.account_opening_date' },resultVar:"abcd" },            
              
            ]
          },
         
          ...controls.displayText({label:"Total Interest",width:"col-sm-2"}),

          {
            inputType: "showdata",
            displaytype:'currency',
            data: "maturity_total_rd",
            textcolor: "black",
            name: "maturity_total_rd",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            }
          },
    ]
  }

  export default recurringdeposit;